export enum RequestOperation {
    None = "None",
    Forward = "Forward",
    Cancel = "Cancel",
    Close = "Close",
    Ready = "Ready",
    Return = "Return",
    Approve = "Approve",
    SendToJde = "SendToJde"
  }